// extracted by mini-css-extract-plugin
module.exports = {"efaxOrdersLabel":"InboxSidebar_efaxOrdersLabel__3w8ZH","unassignedEfaxes":"InboxSidebar_unassignedEfaxes__jBoJ9"};